import './coapplicantReviewPage.scss';

import { ThemeProvider } from '@mui/material/styles';
import { ReactNode } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from '../../../components/Button/Button';
import { Header } from '../../../components/Header/Header';
import { NavigationPane } from '../../../components/NavigationPane/NavigationPane';
import useThemeStore from '../../../store/themeStore/useThemeStore';
import useWorkflowStore from '../../../store/workflowStore/useWorkflowStore';
import { locator } from '../../../testing/e2e-locator/locator';
import CoapplicantEmploymentSection from './CoapplicantEmploymentSection';
import CoapplicantIncomeSection from './CoapplicantIncomeSection';
import CoapplicantPersonalSection from './CoapplicantPersonalSection';
import CoapplicantResidenceSection from './CoapplicantResidenceSection';

export function Component(): ReactNode {
  const { createTheme } = useThemeStore();
  const theme = createTheme();
  const navigate = useNavigate();

  const { t } = useTranslation();
  const { handleSubmit } = useForm();

  const {
    computed: { progress },
    next,
    previous,
  } = useWorkflowStore();

  const previousStep = (): void => {
    navigate(previous());
  };

  const formSubmit = (): void => {
    navigate(next());
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="page coapplicant-review-page">
        <Header
          progress={progress}
          showDrawerToggle
          onBackClick={previousStep}
        />

        <main>
          <form
            data-testid={locator.pages.coapplicantReview.form.root}
            noValidate
            onSubmit={handleSubmit(formSubmit)}
          >
            <div className="form-content">
              <h1 data-testid={locator.pages.coapplicantReview.form.h1}>
                {t('CoapplicantReviewPage.title')}
              </h1>
              <h2 data-testid={locator.pages.coapplicantReview.form.h2}>
                {t('CoapplicantReviewPage.subtitle')}
              </h2>

              <div className="content" style={{ marginBottom: '3rem' }}>
                <CoapplicantPersonalSection />
                <CoapplicantResidenceSection />
                <CoapplicantEmploymentSection />
                <CoapplicantIncomeSection />
              </div>

              <div style={{ marginBottom: '3rem' }}>
                <Button
                  data-testid={
                    locator.pages.coapplicantReview.form.submitButton
                  }
                  fullWidth
                  submit
                >
                  {t('CoapplicantReviewPage.continue')}
                </Button>
              </div>
            </div>
            <footer data-testid={locator.pages.coapplicantReview.footer.root}>
              {t('copyright', { year: new Date().getFullYear() })}
            </footer>
          </form>
        </main>
      </div>

      <NavigationPane withDrawer withUserNameHeader />
    </ThemeProvider>
  );
}

Component.displayName = 'CoapplicantReviewPage';
